import { Component, OnInit } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { UserLoggedIn } from 'src/app/sharedFeatures/models/user-login.model';
import { CurrentUserService } from 'src/app/sharedFeatures/services/current-user.service';
import { NavigationService } from 'src/app/sharedFeatures/services/navigation.service';

@Component({
  selector: 'app-main-content',
  templateUrl: './main-content.component.html',
  styleUrls: ['./main-content.component.scss'],
})
export class MainContentComponent implements OnInit {
  currentUser: UserLoggedIn | null = null;
  private lastNavigatedUrl: string = '';

  constructor(
    private translateService: TranslateService,
    private router: Router,
    private toastrService: ToastrService,
    private navigationService: NavigationService,
    private currentUserService: CurrentUserService
  ) {}

  ngOnInit(): void {
    this.subscribeOnRouterEvents();
    this.setLangChangeSubscriber();
    // Initialise direction from the CURRENT language so the wrapper's
    // ltr-dir/rtl-dir class is correct on first paint. Previously directionRTL
    // stayed at its default until onLangChange fired, so direction-dependent
    // styles (e.g. the action-plan tab count badges) were positioned against
    // the wrong direction on first load and only corrected after a translate.
    const lang =
      this.translateService.currentLang ||
      this.translateService.getDefaultLang();
    this.directionRTL = lang === 'ar';
    this.currentUser = this.currentUserService.getCurrentUser();
  }
  setLangChangeSubscriber(): void {
    this.translateService.onLangChange.subscribe((lang: any) => {
      if (lang.lang == 'ar') {
        this.directionRTL = true;
        this.toastrService.toastrConfig.positionClass = 'toast-bottom-left';
      } else {
        this.directionRTL = false;
        this.toastrService.toastrConfig.positionClass = 'toast-bottom-right';
      }
    });
  }
  subscribeOnRouterEvents(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.isNavigating = true;
      }

      if (event instanceof NavigationEnd) {
        //;
        this.isNavigating = false;
        this.lastNavigatedUrl = event.url.split('?')[0];

        const queryParams = this.router.routerState.snapshot.root.queryParams;
        if (queryParams['token']) {
          this.removeQueryParam();
        }
      }

      if (event instanceof NavigationCancel) {
        this.isNavigating = false;
      }

      if (event instanceof NavigationError) {
        this.isNavigating = false;

        if (event.error.name == 'ChunkLoadError') window.location.reload();
        else {
          // if (this.currentUser) {
          let url = [`/dashboard`];
          this.router.navigate(url);
          // } else {
          //   this.router.navigate(['/login']);
          // }
        }
      }
    });
  }

  removeQueryParam() {
    // Ensure we are not removing query params from an empty URL
    //;

    if (!this.lastNavigatedUrl || this.lastNavigatedUrl === '/') {
      return;
    }

    const queryParams = {
      ...this.router.routerState.snapshot.root.queryParams,
    };
    if (!queryParams['token']) {
      return;
    }
    delete queryParams['token'];

    this.router.navigateByUrl(
      this.router.createUrlTree([this.lastNavigatedUrl], { queryParams }),
      { replaceUrl: true }
    );
  }

  changeLang(lang: string) {
    this.translateService.use(lang);
  }

  toggleMenu() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
  }

  isNavigating: boolean = false;
  title = 'Section Tracker';
  directionRTL: boolean = true;
  isMenuCollapsed: boolean = false;
}
